import React,{useEffect} from 'react' 
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import HomeSlider from '../Component/HomeSlider';
import Header from '../Component/Header';
import News from '../Component/News';
import TopperX from '../Component/TopperX';
import TopperXII from '../Component/TopperXII';
import Birthday from '../Component/Birthday';
import Events  from '../Component/Events';
import Gallery from '../Component/Gallery';
import VideoGallery from '../Component/VideoGallery';
import Message from '../Component/Message';
import Footer from '../Component/Footer';
import OnlineRegistration from'../Component/OnlineRegistration'
import Popup from'../Component/Popup'
const Home = () => {
  useEffect(() => {
    document.title = 'Home - Mary Matha Cmi  Academy';  
}, []); 
  return (
    <>
    {/* <div class="erp_links">
        <a href="https://entab.online/MMCMIA" target="_blank"> 
           <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/Campulogo.png" class="img-fluid" alt="MMATD"/> 
        </a>
     </div> */}
    <Popup/>
    <OnlineRegistration/>
    <Header/>
     <HomeSlider/>
     <div className="container-fluid fwidth">
     <div className="midsection">
     <div className="midsectiondiv fst">
        <div className="midsectionbox">
             <div className="midsectionboximg">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/mission.gif" className="img-fluid" alt="MMATD"/></LazyLoad>
             </div>
             <div className="midsectionboxdesc">
                  <div className="midsectionboxtitle">
                       <h6>MISSION</h6>
                  </div>
                  <div className="midsectionboxpara">
                     <p> We, at Mary Matha School, strive to attain the goal of Excellence not only in academic pursuits but also in every aspect of educational activity. The salubrious climate of this institution, guided by dedicated teachers and supported by parents, nurtures intellectually competent, morally upright, spiritually mature and socially responsible students. Our mission is to form young minds with character, confidence and compassion, ever open to growth and committed to justice, love, truth and peace. </p>
                  </div>
             </div>
        </div>
     </div>
    
     <div className="midsectiondiv scd">
        <div className="midsectionbox">
        <div className="midsectionboximg">
           <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/motto.gif" className="img-fluid" alt="MMATD"/></LazyLoad>
         </div>
             <div className="midsectionboxdesc">  
              
                  <h6> MOTTO</h6>
                     <p>The motto of the school is ‘Strive for Excellence’. Realizing that excellence is never an accident, but the result of deliberate and intentional actions oriented towards excellence, we strive to achieve it. Excellence is our challenge, it is our goal, it is our fervent desire. We want to be considered ‘ The Best’ at whatever we do.</p>
                  </div>
                  
        </div>
     </div>

     <div className="midsectiondiv third">
          <div className="midsectionbox">
        <div className="midsectionboximg">
           <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/vission.gif" className="img-fluid" alt="MMATD"/></LazyLoad>
         </div>
             <div className="midsectionboxdesc"> 
             
                  <div className="midsectionboxpara">
                     <p>The CMI Vision of Education aims at forming leaders who are intellectually competent, spiritually matured, morally upright, psychologically integrated, physically healthy and socially acceptable who will champion the cause of justice, love, truth and peace and who are ever open to further growth.</p>
                  </div>
                  <div className="midsectionboxtitle">
                  <h6> VISION</h6>
              </div>
             </div> 
        </div>
     </div> 
 </div>
 </div>
 <div class="homeabout">
<div className="container-fluid fwidth">
       <div className="row">
           <div className="col-xl-5 col-lg-12">
               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/aboutbg.png" className="img-fluid aboutimg" alt="Mary Matha CMI Academy"/>
           </div>
           <div className="col-xl-7 col-lg-12 homeaboutcontent">
                <div className="maintitle">
                      <p>our school</p>
                      <div> <h1>About   </h1><p> US</p></div>
                </div>
                <div className="aboutmiddec">
                      <p>Mary Matha CMI Academy, is owned by the Kottayam St. Joseph Province of the religious Congregation of the Carmelites of Mary Immaculate (CMI). Mary Matha   Educational endeavors – invites you to the best satisfying edifice, offering everything you can imagine in the arena of education. This School comprises a family of teachers, parents and students under the able and efficient guidance of CMI fathers who have an impeccable track record of managing around 500 Educational institutions, in the most efficient way, throughout India.  </p>
                </div>
                <div className="readmore"> <Link to="/AboutUs"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/btn.png" className="img-fluid aboutimg" alt="Mary Matha CMI Academy"/></Link></div>
          </div>
      </div>
  </div>
</div>
<div className='news-event'> 
<div className='container-fluid fwidth'>
    <div className='row'>
        <div className='col-lg-5 news-bg'>
              <div className="maintitle"> 
              <p>latest news</p>
              <div> <h1>News &  </h1> <p>notices</p></div> 
          </div> 
          <Link to="/News"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/more-icon.png" className='morebtn'></img></Link>  
            <div className='news'>
                
                <div className='news-blk'>
                    <News /> 
                    
                </div>
            </div>
        </div>
        <div className='col-lg-7 event-bg'>
              <div className="maintitle"> 
                  <p>Upcoming events</p>
                  <div> <h1>Events & </h1> <p>announcement</p></div>
                
          </div> 
          <Link to="/Events"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/more-icon.png" className='morebtn'></img></Link>  
            <div className='events'>
                 
                <div className='events-blk'>
                    <Events /> 
                </div>
            </div>
        </div>
    </div>
</div> 
</div>
<div class="facilities"> 
<div class="container-fluid fwidth">
<div class="row">
<div className="col-lg-12">  
<div className="maintitle">   
        <div> <h1> USEFUL </h1> <p>  LINKS</p></div>  
</div>  
</div> 
<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
 <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg1.gif" className="img-fluid"/>
 
</div>
<h3>STRIVE FOR EXCELLENCE</h3>{/*<p> Mary Matha Matriculation higher secondary school was founded in the year 1998 by the Carmelites of Mary Immaculate (CMI) of St. Joseph Province, Kottayam and is crowned by the Mary Matha Educational & Charitable Society. The CMI Congregation, the first of its kind to originate from Indian Soil, is a religious communtiy of Catholic...</p>
<p> Mary Matha Matriculation higher secondary school was founded in the year 1998 by the Carmelites of Mary Immaculate (CMI) of St. Joseph Province, Kottayam and is crowned by the Mary Matha Educational & Charitable Society. The CMI Congregation, the first of its kind to originate from Indian Soil, is a religious communtiy of Catholic...</p>   */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg2.gif" className="img-fluid"/>
</div>
 
<h3>ACHIEVEMENTS</h3>
{/* <p> Vying for honors in District and state levels in Public Exam results has become a habit for Mary Matha Matriculation Higher Secondary School. Year after year, the result of the Public exams had deservingly won the appreciation and applaud of the parents and general public. Heartily congratulations dear students and teachers. Your...</p>
 */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg3.gif" className="img-fluid"/>
 
</div>
<h3>SPORTS</h3>
{/*<p> Sports are the physical activities with different names according to the ways of playing them. Sports are generally liked by almost all the children whether girls or boys. Generally the topic of benefits and importance of sports are argues by the people. And yes, and type of sport is deeply connected with the physical, physiological, mental...</p>
  */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div> 

<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg4.gif" className="img-fluid"/>
 
</div>
<h3>CULTURAL FORUM</h3>
{/*<p> Mary Matha Matriculation higher secondary school makes everyone in this campus realize that life is worth living and we must be fully human and fully alive every moment. The joy of living can be felt only when we celebrate our strength, talents, culture, traditions and festivals. Our school positively provides a conductive and encouraging environment...</p>
  */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div> 
<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg5.gif" className="img-fluid"/>
 
</div>
<h3>NEWSLETTER</h3>
{/* <p> Newsletter give prospective parents a relatively unscripted glimpse into the daily life of the school, showing them what it would be like. The newsletter can also be a tangible demonstration of the school’s values at work through various articles and features content.</p>
 */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div> 
<div class="col-xl-4 col-lg-6 col-md-6">
<div class="facilitiesbox">
<div className="facilitiesimg">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/usefulimg6.gif" className="img-fluid"/>
 
</div>
<h3>FACULTY</h3>
{/*  <p></p> */}
<div className='button m-auto '><Link to="/">Explore <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/arrowicn.png" className="img-fluid"/></Link></div>
</div>
</div> 

</div>
</div>
</div>
<div className="messagesec">
<div className="container-fluid fwidth">
  <div className="row">
    <div className="col-lg-12">
        <div className="maintitle"> 
                <p>Message section</p>
                <div> <h1> from the </h1> <p>  desk of</p></div>
                
        </div>  
    </div>
    <div className="col-lg-12">
      <Message />
    </div>
  </div>
</div>
</div>
<div className="topper_bg">
<div className="container-fluid section-title">
  <div className='row'>
    <div className='col-xl-8 col-lg-8'>
      <div className='row'> 
      <div className='col-md-12'>
      <div className="maintitle">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/stars.gif" className='img-fluid m-auto d-block titleimg' /></LazyLoad>
            <p>Our Toppers</p>
            <div> <h1>shining  </h1> <p>stars</p></div>
          { /*   <Link to="/"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/more-icon.png" className='morebtn'></img></Link>  */}
     </div> 
    </div>
     <div className="col-lg-6">
      <div className='topper-block'>
        <div className='title'>
          <h4>XII Toppers</h4>
          <div className='arrrow-btn'> 
          </div>
        </div>
        <TopperXII />
      </div>
        
    </div> 
    <div className="col-lg-6">
      <div className='topper-block'>
        <div className='title'>
          <h4>X Toppers</h4> 
          <div className='arrrow-btn'>
            {/* <Link to="/">
            <i className="bi bi-chevron-right"></i></Link>*/}
          </div>
        </div>
        <TopperX />
      </div>
    
    </div>

    
      </div>
    </div>
    <div className='col-xl-4 col-lg-4 birthdayhead'> 
      <div className="maintitle">
       <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/birthday.gif" className='img-fluid m-auto d-block titleimg' /></LazyLoad>
       <p>Born on This Day</p>
       <div> <h1>today’s </h1> <p>birthday</p></div>
        { /*   <Link to="/"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/more-icon.png" className='morebtn'></img></Link>  */}
    </div>   
    <div className="col-lg-12">
      <div className='topper-block'>
      <div className='title'>
      <h4></h4>
      <div className='arrrow-btn'> 
      </div>
    </div>
        <Birthday />
      </div> 
    </div> 
    </div>
  </div> 
</div>
</div> 
<div className="homegallerysec">
<div className="container-fluid fwidth">
  <div className="row"> 
        <div className='col-md-12'>
            <div className="maintitle">
                  <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/galleryicn.gif" className='img-fluid m-auto d-block titleimg' /></LazyLoad>
                    <p>momories in media</p>
                    <div> <h1>Gallery  </h1> <p>section</p></div>
                    
            </div> 
      </div>
    <div className="col-lg-9"> 
      <Gallery />  
    </div>
    <div className="col-lg-3"> 
      <VideoGallery /> 
    </div>
    <div className="readmore"> <Link to="/Gallery"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/btn.png" className="img-fluid mx-auto d-block" alt="Mary Matha CMI Academy"/></Link></div>
  </div>
</div>
</div>  
<Footer/>
    </>
  )
}

export default Home
